import React from 'react';
import { Star } from 'lucide-react';
import { FadeIn } from './FadeIn';
const testimonials = [{
  quote: 'Lo apliqué y me respondió en menos de 15 minutos después de ignorarme por días.',
  name: 'María G.'
}, {
  quote: 'Pensé que ya lo había perdido. Usé una de las frases y me escribió esa misma noche.',
  name: 'Valentina R.'
}, {
  quote: 'Dejé de perseguirlo y ahora es él quien me busca todos los días.',
  name: 'Camila S.'
}];
export function Testimonials() {
  return <section className="py-16 px-6 bg-[#0a0a0a] relative" data-id="element-281">
      <div className="max-w-5xl mx-auto" data-id="element-282">
        <FadeIn data-id="element-283">
          <h2 className="font-serif text-3xl md:text-5xl font-bold mb-10 text-center" data-id="element-284">
            Ellas ya no esperan{' '}
            <span className="text-brand-rose italic" data-id="element-285">respuestas...</span>
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-286">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-287">
              <div className="bg-[#161616] p-6 rounded-2xl border border-white/5 h-full flex flex-col" data-id="element-288">
                <div className="flex gap-1 mb-4" data-id="element-289">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-290" />)}
                </div>
                <p className="text-brand-cream text-lg italic mb-6 flex-grow" data-id="element-291">
                  "{testimonial.quote}"
                </p>
                <p className="text-brand-lightGray font-medium text-sm" data-id="element-292">
                  — {testimonial.name}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}